import { Injectable } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';

@Injectable({
  providedIn: 'root'
})
export class FlatMenuService {

  constructor() { }

//Function to get top Menu
makeTopMenuItems(items:NbMenuItem[]): NbMenuItem[]{
  console.log(items);
  const result: NbMenuItem[] = [];
  items.forEach(item => {
    if(item.children != null){
      delete item.children;
    }
  });
  console.log(result);
  return result;
}


// Function to flatten the array
flattenItems(items: NbMenuItem[]): NbMenuItem[] {
  const result: NbMenuItem[] = [];
  
  // Helper function to recursively flatten items
  function flatten(itemArray: NbMenuItem[]) {
    for (const item of itemArray) {
      result.push(item); // Add the current item
      if (item.children) {
        flatten(item.children); // Recursively flatten the children
      }
    }
  }

  flatten(items); // Start flattening from the top level
  return result;
}

// Example usage
//const flatItems = flattenItems(items);
//console.log('Flattened items:', flatItems);

}
